import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import React from 'react';

import { AnnouncementAnchor } from '@/contexts/announcements/AnnouncementAnchor.comp.tsx';
import { useAnnouncements } from '@/contexts/announcements/Announcements.context.tsx';
import { AnnouncementAnchorKey } from '@/contexts/announcements/announcements.definitions.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

export const TopBarAnnouncementsButton: React.FC = () => {
  const { t } = useTranslationWithPrefix('components.announcements');
  const { currentRouteUnseenCount, openPanel } = useAnnouncements();

  return (
    <Badge badgeContent={currentRouteUnseenCount} color="secondary" max={9}>
      <AnnouncementAnchor
        anchorKey={AnnouncementAnchorKey.TOP_BAR_ANNOUNCEMENTS}
        component="div"
        sx={{ display: 'inline-flex', lineHeight: 0 }}
      >
        <Button endIcon={<TipsAndUpdatesOutlinedIcon />} onClick={openPanel} variant="outlined">
          {t('button.label')}
        </Button>
      </AnnouncementAnchor>
    </Badge>
  );
};
